export default __webpack_public_path__ + "static/media/nft.7ae829d3.png";